module.exports = __webpack_public_path__ + "media/icons/widget-icon-1@3x-ef9f5e0c.svg";